<template>
  <ym-loadmore v-if="list.length > 0"
               class="work-list"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <work-list-block :list="list" />
  </ym-loadmore>
  <div v-else
       class="empty"
  >
    暂无作品
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import WorkListBlock from '@/pages/Work/components/WorkListBlock';
  import { getWorkList } from '@/services/work';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'WorkList',
    components: {
      'ym-loadmore': Loadmore,
      WorkListBlock,
    },
    props: {
      works: {
        type: Array,
        required: true,
      },
      nextStart: {
        type: Number,
        required: true,
      },
      query: {
        type: Object,
      },
    },
    data() {
      return {
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
      };
    },
    watch: {
      works(val) {
        this.list = val;
      },
      nextStart(val) {
        this.start = val;
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;

        const { query, start } = this;
        const params = Object.assign({
          limit: LIMIT,
          start,
        }, query);
        const data = await getWorkList(params, isLoadMore);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
    },
    created() {
      this.list = this.works;
      this.start = this.nextStart;
    },
  };
</script>
